import React, { useState, useEffect } from "react";
import styles from "./FeedPage.module.css";
import FeedHeader from "./components/FeedHeader";
import FeedSidebar from "./components/FeedSidebar";
import FeedTimeline from "./components/FeedTimeline";
import FeedSuggestionsPanel from "./components/FeedSuggestionsPanel";
import StandardPageHelmet from "../../seo/components/StandardPageHelmet";
import useSEO from "../../seo/use-seo";

export default function FeedPage() {
  const seo = useSEO("home");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchFilter, setSearchFilter] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className={styles.pageContainer}>
      <StandardPageHelmet seo={seo} />

      {/* Top Navigation Header */}
      <FeedHeader
        onToggleMobileMenu={() => setMobileMenuOpen((prev) => !prev)}
        onSearchChange={(q) => setSearchFilter(q)}
      />

      {/* Main 3-Column Content Layout */}
      <div className={styles.mainLayout}>
        {/* Left Sidebar */}
        <FeedSidebar
          mobileOpen={mobileMenuOpen}
          onCloseMobile={() => setMobileMenuOpen(false)}
        />

        {/* Center Timeline Feed */}
        <FeedTimeline searchFilter={searchFilter} />

        {/* Right Suggestions & Trending Panel */}
        <FeedSuggestionsPanel />
      </div>
    </div>
  );
}
